<div class="mobile-progress" data-testid="wizard-progress-mobile">
  @for (step of steps; track $index; let i = $index) {
    <div class="segment" [class.filled]="i <= currentStep"></div>
  }
</div>

<div class="desktop-rail" data-testid="wizard-step-rail">
  @for (step of steps; track $index; let i = $index) {
    <button
      type="button"
      class="rail-item"
      [class.current]="i === currentStep"
      (click)="stepSelected.emit(i)"
      [attr.data-testid]="'wizard-rail-step-' + i"
    >
      <span class="rail-circle" [class.done]="i < currentStep" [class.current]="i === currentStep">
        @if (i < currentStep) {
          <app-icon name="check" [size]="13" />
        } @else {
          {{ i + 1 }}
        }
      </span>
      <span class="rail-label">{{ step }}</span>
    </button>
  }
</div>
